import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import App from './App';

import configureStore from './redux/store';
import { Store } from 'redux';
import { IApplicationState } from './redux/reducers';

const store : Store<IApplicationState> = configureStore();
ReactDOM.render(<App store={store} />, document.getElementById('root'));
serviceWorker.register();
